<app-loading-state [isLoading]="isLoading" [loadedContent]="loadedContent"> </app-loading-state>

<ng-template #loadedContent>
	<div class="profile-settings-container">
		<div class="content">
			<form [formGroup]="profileForm">
				<div class="form-container">
					<app-alert
						[dismissible]="true"
						content="This is where you can update your profile information, including your name, phone number, email address, and password. Keeping these details up to date ensures seamless communication and account security."
					></app-alert>
					<h4 class="text-primary">Personal Details</h4>

					<div class="form-row">
						<div class="label text-primary">Full Name</div>

						<app-standard-control
							class="content"
							type="text"
							name="displayName"
							[formGroup]="profileForm"
							label="Full Name"
							labelPlacement="none"
							placeholder="Full Name"
							autocomplete="name"
						>
						</app-standard-control>
					</div>

					<div class="form-row">
						<div class="label text-primary">Phone Number</div>
						<div class="content action-control">
							<app-phone-number-control
								class="control"
								[formGroup]="profileForm"
								name="phoneNumber"
							></app-phone-number-control>
							<button type="button" class="btn btn-sm btn-outline-primary action" (click)="handleUpdatePhoneNumber()">
								<i class="bi bi-telephone"></i>
								Edit
							</button>
						</div>
					</div>

					<div class="form-row">
						<div class="label text-primary">Email Address</div>

						<div class="content">
							<app-standard-control
								type="email"
								name="email"
								[formGroup]="profileForm"
								label="Email Address"
								labelPlacement="none"
								placeholder="Email Address"
								autocomplete="email"
							>
							</app-standard-control>

							<small class="text-muted fst-italic">
								Your email address cannot be changed. If you need to update your email address, please contact support.
							</small>
						</div>
					</div>

					<ng-container *ngIf="authUser?.email">
						<div class="form-row">
							<div class="label text-primary">Email Verified</div>
							<div class="content action-control">
								<app-switch-control class="control" name="emailVerified" [formGroup]="profileForm"></app-switch-control>
								<ng-container *ngIf="!authUser?.emailVerified">
									<button
										type="button"
										class="btn btn-sm btn-outline-primary action"
										(click)="handleSendEmailVerification()"
									>
										<i class="bi bi-envelope-check"></i>
										Verify Email
									</button>
								</ng-container>
							</div>
						</div>
					</ng-container>

					<div class="form-row">
						<div class="label text-primary">Authentication Methods</div>

						<div class="content text-primary">
							{{ signInProviders.join(' | ') | titlecase }}
						</div>
					</div>

					<div class="form-row">
						<div class="label text-primary">Change Password</div>

						<button type="button" class="content btn btn-sm btn-outline-primary" (click)="handleUpdatePassword()">
							<i class="bi bi-lock"></i>
							Change Password
						</button>
					</div>
				</div>
			</form>
		</div>
		<div class="footer">
			<button
				type="button"
				class="btn btn-sm btn-outline-danger btn-width"
				(click)="handleCancel()"
				[disabled]="profileForm.pristine"
			>
				Cancel
			</button>
			<button
				type="button"
				class="btn btn-sm btn-primary btn-width"
				(click)="handleSave()"
				[disabled]="profileForm.invalid || profileForm.pristine"
			>
				<ng-container *ngIf="isSaving; else saveText">
					<div class="spinner-border spinner-border-sm" role="status">
						<span class="visually-hidden">Loading...</span>
					</div>
				</ng-container>
				<ng-template #saveText> Save </ng-template>
			</button>
		</div>
	</div>
</ng-template>
